<template>
 <div class="title-bar">
  <div class="info">
   <h3 class="title">{{ title }}</h3>
   <p class="sub-title" v-if="subTitle">{{ subTitle }}</p>
  </div>
  <div class="more" v-if="needMore" @click="handleClick">More</div>
 </div>
</template>
<script>
export default {
  props: {
    title: String,
    subTitle: String,
    needMore: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
  },
  methods: {
    handleClick() {
      this.$emit('goMore');
    },
  },
};
</script>

<style lang="less" scoped>
.title-bar {
  display: flex;
  padding: 4px 16px;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  line-height: 16px;
  color: #757575;
  font-weight: 700;
  .info {
    position: relative;
    padding-left: 8px;
    .title {
      font-size: @fontMedium;
      font-weight: 700;
      line-height: 23px;
      color: #000;
    }
    .sub-title {
      font-size: 16px;
      color: #B3B3B3;
    }
    &::before {
      content: '';
      width: 4px;
      position: absolute;
      margin: 5px 0;
      background: #3BDCBC;
      top: 0;
      left: 0;
      bottom: 0;
      border-radius: 10px;
    }
  }
  .more {
    display: flex;
    align-items: center;
    &::after {
      content: '';
      width: 24px;
      height: 24px;
      background: url('~@/assets/images/icon/arrow.png') center no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
